import { motion } from "framer-motion";
import { CalendarCheck, Phone, Car } from "lucide-react";

const steps = [
  {
    num: "01",
    icon: Phone,
    title: "Appelez ou réservez en ligne",
    description: "Remplissez le formulaire ou appelez-nous au 06 52 62 07 47. Réponse immédiate.",
    color: "text-amber-400",
    bg: "bg-amber-500/10",
    border: "border-amber-500/30",
  },
  {
    num: "02",
    icon: CalendarCheck,
    title: "On confirme votre course",
    description: "Nous vous rappelons pour confirmer la date, l'heure et les détails de votre trajet.",
    color: "text-blue-400",
    bg: "bg-blue-500/10",
    border: "border-blue-500/30",
  },
  {
    num: "03",
    icon: Car,
    title: "Votre chauffeur arrive",
    description: "Ponctuel et souriant, votre chauffeur vous conduit en toute sérénité à destination.",
    color: "text-emerald-400",
    bg: "bg-emerald-500/10",
    border: "border-emerald-500/30",
  },
];

export default function HowItWorks() {
  return (
    <section className="py-20 md:py-28 relative overflow-hidden" data-testid="how-it-works">
      {/* Subtle background accent */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-amber-500/3 blur-[120px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-amber-400 font-tagline text-sm tracking-[0.3em] uppercase font-semibold">
            Simple et rapide
          </span>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-white mt-3">
            Comment ça marche ?
          </h2>
          <p className="text-zinc-400 mt-3 text-base md:text-lg">
            Réserver votre taxi n'a jamais été aussi simple.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {steps.map((s, i) => (
            <motion.div
              key={s.num}
              className={`relative p-8 rounded-2xl border ${s.border} ${s.bg} backdrop-blur-sm group`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
              whileHover={{ y: -4, transition: { duration: 0.3 } }}
              data-testid={`step-${i}`}
            >
              {/* Step number */}
              <span className={`text-5xl font-bold ${s.color} opacity-20 absolute top-4 right-6 font-tagline`}>
                {s.num}
              </span>

              <div className={`inline-flex p-3 rounded-xl ${s.bg} border ${s.border} mb-5`}>
                <s.icon className={`h-6 w-6 ${s.color}`} />
              </div>

              <h3 className="text-lg font-bold text-white mb-2">{s.title}</h3>
              <p className="text-sm text-zinc-400 leading-relaxed">{s.description}</p>

              {/* Connector line */}
              {i < 2 && (
                <div className="hidden md:block absolute top-1/2 -right-4 w-8 h-px bg-white/10" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
